
import { mapGetters } from "vuex"

export default {
  props: ["error"],
  layout: "empty",

  data() {
    return {
      SEO: {
        title: "Error",
        index: false
      }
    }
  },

  watch: {
    $route() {
      this.$store.commit("CONFIG/RESET_ALL")
    }
  },

  computed: {
    ...mapGetters({
      config: "CONFIG/CONFIG"
    }),

    isServerError() {
      return this.error.statusCode === 500
    },

    isNotFoundError() {
      return this.error.statusCode === 404
    }
  },

  mounted() {
    this.$store.commit("CONFIG/RESET_ALL")
  }
}
